import { EMAIL_FIELD_NAMES, trimIfEmailField } from "./emailFormat";

const PASSWORD_FIELD_NAMES = new Set([
  "password",
  "newpassword",
  "re_pass",
  "confirmPassword",
  "oldPassword",
]);

/** Fields that must not contain spaces; trim on every change. */
export const TRIM_ON_CHANGE_FIELDS = new Set<string>(
  (EMAIL_FIELD_NAMES as readonly string[]).concat([
    "username",
    "otp",
    "primaryKey",
  ]),
);

export function shouldSkipTrim(name: string): boolean {
  return PASSWORD_FIELD_NAMES.has(name);
}

export function trimIfOnChangeField(name: string, value: unknown): unknown {
  if (typeof value !== "string" || shouldSkipTrim(name)) {
    return value;
  }
  if (TRIM_ON_CHANGE_FIELDS.has(name)) {
    return value.trim();
  }
  return trimIfEmailField(name, value);
}

export function trimIdentifierFields<T extends Record<string, any>>(
  data: T,
  keys: (keyof T | string)[],
): T {
  const next = { ...data };
  for (const key of keys) {
    const name = String(key);
    if (shouldSkipTrim(name)) continue;
    const value = next[key as keyof T];
    if (typeof value === "string") {
      (next as Record<string, unknown>)[name] = value.trim();
    }
  }
  return next;
}
